const superAdmin = {
  namespaced: true,
  state: {
    organisations: [],
    users: [],
    licenses: [],
    contacts: []
  },
  mutations: {
    SET_ORGANISATIONS(state, organisations) {
      state.organisations = organisations
    },
    SET_USERS(state, users) {
      state.users = users
    },
    SET_LICENSES(state, licenses) {
      state.licenses = licenses
    },
    ADD_USER(state, user) {
      state.users = [...state.users, user]
    },
    ADD_ORGANISATION(state, payload) {
      state.organisations = [...state.organisations, payload.organisation]
      state.licenses = [...state.licenses, payload.license]
      state.contacts = [...state.contacts, ...payload.contacts]
    },
    UPDATE_USER(state, user) {
      console.log(state.users)
      console.log(user)
      state.users = state.users.map(u => (u = u._id === user._id ? user : u))
    }
  },
  actions: {
    async fetchUsers({ commit }) {
      try {
        const { data } = await this.$api.fetchAllUsers()
        commit('SET_USERS', data)
        return Promise.resolve()
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async fetchOrgs({ commit }) {
      try {
        const { data } = await this.$api.fetchOrganisations()
        commit('SET_ORGANISATIONS', data)
        return Promise.resolve()
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async fetchLicenses({ commit }) {
      try {
        const { data } = await this.$api.fetchLicenses()
        commit('SET_LICENSES', data)
        return Promise.resolve()
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async createUser({ commit }, user) {
      try {
        const { data } = await this.$api.createUser(user)
        commit('ADD_USER', data)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async createOrganisation({ commit }, payload) {
      try {
        const { data } = await this.$api.createOrganisation(payload)
        commit('ADD_ORGANISATION', data)
        return Promise.resolve()
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async editOrganisation({ commit }, payload) {
      try {
        await this.$api.editOrganisation(payload)
        return Promise.resolve()
      } catch (err) {
        return Promise.reject(err)
      }
    }
  },
  getters: {
    users: state => state.users.slice(),
    organisations: state => state.organisations,
    licenses: state => state.licenses,
    contacts: state => state.contacts
  }
}

export default superAdmin
